import * as React from "react";
// import { Text, View } from "@aws-amplify/ui-react";
import { Box } from "@mui/material";

export const DispHikkou = (props: any) => {
  return (
    <Box
      sx={{
        maxWidth: 120,
        fontSize: 15,
        fontWeight: 600,
        color: "rgba(236,105,54,10)",
        fontFamily: "Hiragino Sans",
        paddingLeft: 2,
      }}
    >
      必須
    </Box>
  );
};
